/**
 * GraphQL fragment for CallTrackingPhone entity
 * Defines the fields to be fetched for call tracking phone data
 * 
 * @see Requirements 7.5
 */
export const CallTrackingPhoneFields = {
  ID: true,
  PHONE_NUMBER: true,
  IS_DEFAULT: true,
  IS_RESERVED: true,
};
